import { createFileRoute, redirect } from '@tanstack/react-router';

// Legacy schedule-review path. The "Needs a tech" queue now lives inside
// the Dispatch cockpit (/dashboard/dispatch) — redirect old links there.
export const Route = createFileRoute('/_dashboard/dashboard/unscheduled/')({
  beforeLoad: () => {
    throw redirect({
      to: '/dashboard/dispatch',
      search: {
        date: undefined,
        // Leave the colour mode unset so the route default (Job type) applies —
        // pinning `status` here stuck in the URL and hid the job-type colours.
        colorBy: undefined,
        map: 'off',
        bookingId: undefined,
        territoryId: undefined,
        jobTypeId: undefined,
        businessUnitId: undefined,
        priority: undefined,
        origin: undefined,
        exceptions: undefined,
      },
      replace: true,
    });
  },
});
